<template>
	<DefaultLayout>
		<div class="main-wrapper mt-6">
			<div class="flex lg:space-x-8 justify-between">
				<aside class="w-72 hidden lg:block">
					<h4 class="font-medium text-lg mb-8">
						{{ $t("account.greeting") }}, {{ getUser?.Account?.Name }}
					</h4>
					<ul class="space-y-1 mb-8">
						<li v-for="link in accountLinks" :key="link.to">
							<NuxtLink
								:to="link.to"
								class="flex items-center px-3 py-2 text-gray-700 text-sm font-medium"
							>
								<span>{{ $t(link.titleKey) }}</span>
							</NuxtLink>
						</li>
					</ul>
					<div>
						<button
							class="flex items-center border border-gray-300 shadow-sm py-2 px-4 hover:bg-gray-50"
							@click="invokeLogout()"
						>
							<ArrowRightOnRectangleIcon class="h-5 w-5 text-gray-500" />
							<span class="ml-2 text-gray-700 text-sm font-medium">{{
								$t("account.logout")
							}}</span>
						</button>
					</div>
				</aside>
				<main class="flex-1 w-full xl:pl-26">
					<slot />
				</main>
			</div>
		</div>
	</DefaultLayout>
</template>

<script setup lang="ts">
import { ArrowRightOnRectangleIcon } from "@heroicons/vue/24/outline";
import { storeToRefs } from "pinia";
import DefaultLayout from "./default.vue";
import { ROUTES } from "~/utils/routes";

const { getUser } = storeToRefs(userStore());

const localePath = useLocalePath();
const cartStore = useCartStore();

const { logOut } = useNorcePwa();
const { initLayoutData } = useLayoutInit();

const router = useRouter();

await initLayoutData();

// `titleKey` resolved with `$t` in the template (not `useI18n()` in
// setup) — keeps the script free of i18n composables and matches the
// tendenz account layout. Used by the desktop sidebar; mobile uses the
// header drawer (AccountMobileMenu).
const accountLinks = computed(() => [
	{ titleKey: "account.account_overview", to: localePath(ROUTES.ACCOUNT.ROOT) },
	{ titleKey: "account.my_profile", to: localePath(ROUTES.ACCOUNT.PROFILE) },
	{ titleKey: "account.addresses", to: localePath(ROUTES.ACCOUNT.ADDRESS) },
	{
		titleKey: "account.payment_methods",
		to: localePath(ROUTES.ACCOUNT.PAYMENT)
	},
	{ titleKey: "account.orders", to: localePath(ROUTES.ACCOUNT.ORDER) },
	{
		titleKey: "purchase_lists.title",
		to: localePath(ROUTES.ACCOUNT.PURCHASE_LISTS)
	}
]);

const invokeLogout = async () => {
	await logOut();
	useWishlistStore().$reset();
	userStore().setUser(null);
	cartStore.$reset();
	router.push(localePath("/"));
};
</script>
